export default __webpack_public_path__ + "static/media/flag.6bd080ea.png";